import { Stack } from "expo-router";
import { surface, text, typography } from "@/src/theme/tokens";
import { Platform } from "react-native";

export default function MessagesLayout() {
  return (
    <Stack
      screenOptions={{
        contentStyle: { backgroundColor: surface.secondary },
        headerStyle: { backgroundColor: surface.secondary },
        headerTintColor: text.primary,
        headerTitleStyle: { fontFamily: typography.family.semibold },
        headerShadowVisible: false,
      }}
    >
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen name="direct/[id]" options={{ headerShown: false }} />
      <Stack.Screen name="[id]" options={{ headerShown: false }} />
      <Stack.Screen name="new" options={{ title: "Nouvelle discussion", headerShown: Platform.OS !== "web" }} />
      <Stack.Screen name="group-thread/[id]" options={{ headerShown: false }} />
      <Stack.Screen name="group/[id]" options={{ headerShown: false }} />
      <Stack.Screen name="group/add-members/[id]" options={{ headerShown: false }} />
    </Stack>
  );
}
